var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('FormView',{attrs:{"data":_vm.$store.getters['courierService/detailData'],"fields":_vm.$store.getters['courierService/tableFields']},on:{"load":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }